export default defineAppConfig({
    title: 'Kichieats',
    environment: process.env.NODE_ENV,
    version: '1.0',
    defaultSeoImg: 'https://img.kichieats.ph/defaultSeoImg.png', 
    head: {
      script: [
        {
          src: 'https://www.googletagmanager.com/gtag/js?id=G-4NY4VVTBWD',
          async: true
        },
        {
          children: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('config', 'G-4NY4VVTBWD');
            gtag('config'); 
          ` 
        }
      ]
    } 
  })  